"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = require("lodash");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _reactInfiniteScrollComponent = _interopRequireDefault(require("react-infinite-scroll-component"));

var _columnAscending = _interopRequireDefault(require("../../assets/icons/column-ascending.svg"));

var _columnUnsorted = _interopRequireDefault(require("../../assets/icons/column-unsorted.svg"));

var _columnsDescending = _interopRequireDefault(require("../../assets/icons/columns-descending.svg"));

var _dragAndDrop = _interopRequireDefault(require("../../assets/icons/drag-and-drop.svg"));

var _search = _interopRequireDefault(require("../search"));

var _constants = require("./constants");

var _ColumnFilter = _interopRequireDefault(require("./ColumnFilter"));

var _ExpandRowIcon = _interopRequireDefault(require("./ExpandRowIcon"));

var _TableWithNoData = _interopRequireDefault(require("./TableWithNoData"));

var _excluded = ["row", "columns", "rowIndex", "highlightedRow", "allowRowSelect", "allowDraggableRow", "handleExpandedRows", "expandedRows", "noDataMessage"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-table-container {\n  width: 100%;\n  height: 100%;\n  min-width: 26.5rem; }\n  .bds-table-container .bds-table-sort-icon-resize-container {\n    display: flex; }\n  .bds-table-container .bds-table {\n    width: 100%;\n    height: 100%;\n    display: table;\n    position: relative; }\n  .bds-table-container .bds-table-search {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    box-sizing: border-box;\n    min-height: 3.5rem;\n    border-bottom: none;\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    flex-wrap: wrap;\n    padding-right: 0.5rem;\n    background: #ffffff;\n    max-width: 100%;\n    min-width: 26.5rem; }\n  .bds-table-container .bds-table-search-container {\n    display: flex;\n    padding-left: 0.5rem;\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem; }\n    .bds-table-container .bds-table-search-container .search-container {\n      border-color: #a8a8a8; }\n  .bds-table-container table.bds-table thead th {\n    min-width: 5.5rem; }\n  .bds-table-container .bds-table-header-cell {\n    box-sizing: border-box;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: #393939;\n    border-bottom: 0.03125rem solid #c6c6c6;\n    padding-right: 0;\n    font-size: 0.875rem;\n    min-width: 5.5rem;\n    height: 3.5rem;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background: #ffffff; }\n  .bds-table-container .bds-table-header-cell-no-background {\n    box-sizing: border-box;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: #393939;\n    border-bottom: 0.03125rem solid #c6c6c6;\n    padding-right: 0;\n    font-size: 0.875rem;\n    min-width: 5.5rem;\n    height: 3.5rem;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1; }\n  .bds-table-container .bds-table-header-cell:first-child {\n    border-left: none; }\n  .bds-table-container .bds-table-header-cell:last-child {\n    border-right: none; }\n  .bds-table-container .bds-table-header-text-icon {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-width: 0;\n    overflow: hidden;\n    height: 100%; }\n  .bds-table-container .bds-table-resizer {\n    display: flex;\n    background: none;\n    width: 0.03125rem;\n    height: 2rem;\n    min-width: 0;\n    padding: 0 1px;\n    cursor: col-resize; }\n  .bds-table-container .bds-table-resizer-hover {\n    background: #a8a8a8; }\n  .bds-table-container .bds-table-header-text {\n    font-weight: 700;\n    font-family: \"OpenSansRegular\";\n    letter-spacing: 0.03125rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -ms-text-overflow: ellipsis;\n    min-width: 0;\n    white-space: nowrap; }\n  .bds-table-container .bds-table-header-text-cursor {\n    cursor: pointer; }\n  .bds-table-container .bds-table-header-icon {\n    display: flex;\n    align-items: center;\n    cursor: pointer; }\n  .bds-table-container .bds-table-cell {\n    box-sizing: border-box;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: #393939;\n    font-size: 0.875rem;\n    font-family: \"OpenSansRegular\";\n    line-height: 1.1875rem;\n    letter-spacing: 0.02rem;\n    padding-top: 0.84375rem;\n    padding-bottom: 0.90625rem;\n    border-bottom: 0.03125rem solid #c6c6c6;\n    max-width: 0; }\n  .bds-table-container .bds-table-cell-render {\n    box-sizing: border-box;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: #393939;\n    font-size: 0.875rem;\n    font-family: \"OpenSansRegular\";\n    line-height: 1.1875rem;\n    letter-spacing: 0.02rem;\n    border-bottom: 0.03125rem solid #c6c6c6;\n    max-width: 0; }\n  .bds-table-container .bds-table-expanded-row {\n    background-color: #EEEEEE;\n    transition: height 0.5s ease-in; }\n  .bds-table-container .bds-table-expanded-row-cell-render {\n    line-height: 3.1875rem; }\n  .bds-table-container .bds-table-expanded-row-no-data-found {\n    display: flex;\n    justify-content: space-around; }\n  .bds-table-container .bds-table-expand-row {\n    display: flex;\n    gap: 2px;\n    align-items: center; }\n  .bds-table-container .bds-table-expand-row-icons {\n    cursor: pointer; }\n  .bds-table-container .bds-table-row > .bds-table-cell-render:last-child {\n    border-right: none; }\n  .bds-table-container .bds-table-cell-custom {\n    box-sizing: border-box;\n    width: 100%;\n    border-left: none;\n    overflow: hidden; }\n  .bds-table-container .bds-table-row td:last-child .bds-table-cell-custom {\n    border-right: none; }\n  .bds-table-container .bds-table-row td.bds-table-cell:last-child {\n    border-right: none; }\n  .bds-table-container .bds-table-row-selectable:hover {\n    cursor: pointer; }\n  .bds-table-container .bds-table-row-highlighted {\n    background-color: #e0e0e0; }\n  .bds-table-container .bds-table-row:hover {\n    background-color: #e0e0e0; }\n  .bds-table-container .bds-table-row:hover .bds-table-cell,\n  .bds-table-container .bds-table-cell-render {\n    border-right-color: #e0e0e0;\n    border-left-color: #e0e0e0; }\n  .bds-table-container .bds-overflow-menu-item {\n    font-size: 0.875rem;\n    font-family: \"OpenSansRegular\"; }\n  .bds-table-container .bds-overflow-menu-item:hover {\n    background-color: #e0e0e0;\n    letter-spacing: 0.02rem; }\n  .bds-table-container table,\n  .bds-table-container tbody,\n  .bds-table-container thead,\n  .bds-table-container tr,\n  .bds-table-container th,\n  .bds-table-container td {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    outline: 0;\n    font-size: 100%;\n    vertical-align: middle;\n    background: transparent;\n    border-collapse: unset;\n    text-indent: initial;\n    border-spacing: 0; }\n  .bds-table-container td.bds-table-cell {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -ms-text-overflow: ellipsis;\n    height: 3rem;\n    white-space: nowrap; }\n  .bds-table-container table.bds-table {\n    table-layout: fixed; }\n  .bds-table-container .table-infinite-scroll-inside-modal {\n    -ms-overflow-style: none;\n    scrollbar-width: none; }\n    .bds-table-container .table-infinite-scroll-inside-modal::-webkit-scrollbar {\n      display: none; }\n  .bds-table-container .bds-add-new-row {\n    margin-top: 20px; }\n    .bds-table-container .bds-add-new-row table,\n    .bds-table-container .bds-add-new-row th,\n    .bds-table-container .bds-add-new-row td {\n      background-color: #F4F4F4;\n      border: none; }\n    .bds-table-container .bds-add-new-row th {\n      height: 1rem; }\n    .bds-table-container .bds-add-new-row table {\n      padding-top: 15px;\n      padding-bottom: 15px; }\n  .bds-table-container .bds-empty-new-row-header th {\n    height: 1px; }\n  .bds-table-container .bds-table-column-filter {\n    display: flex;\n    align-items: center;\n    margin-top: 0px; }\n  .bds-table-container .filter-menus {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    color: #333333;\n    border-radius: 6px;\n    position: absolute;\n    min-width: 200px;\n    right: 0px;\n    top: 50px; }\n    .bds-table-container .filter-menus-menu-divider {\n      border: 0;\n      border-top: 1px solid rgba(0, 0, 0, 0.1); }\n    .bds-table-container .filter-menus-filter-list {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      overflow-y: auto;\n      max-height: 280px; }\n    .bds-table-container .filter-menus-action-btns {\n      margin-right: 8px;\n      margin-bottom: 8px;\n      justify-content: flex-end;\n      display: flex;\n      flex-direction: row;\n      gap: 10px; }\n    .bds-table-container .filter-menus-no-data-found {\n      padding: 8px 12px; }\n    .bds-table-container .filter-menus-filter-menus-list {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      padding: 8px 12px; }\n    .bds-table-container .filter-menus-clear-all {\n      margin-left: 13px;\n      margin-top: 10px;\n      margin-bottom: 10px; }\n  .bds-table-container .filter-icon {\n    width: 22px;\n    height: 22px;\n    cursor: pointer; }\n";
  var fileName = "compone_table";
  var element = document.querySelector("style[data-sass-component='compone_table']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var useTableWidth = function useTableWidth() {
  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  (0, _react.useLayoutEffect)(function () {
    var element = document.getElementsByClassName(_constants.classes.table)[0];

    var updateWidth = function updateWidth() {
      if (element !== null && element !== void 0 && element.offsetWidth) {
        setWidth(element.offsetWidth);
      }
    };

    window.addEventListener(_constants.resizeEvent, updateWidth);
    updateWidth();
    return function () {
      return window.removeEventListener(_constants.resizeEvent, updateWidth);
    };
  }, []);
  return width;
};

var Table = function Table(_ref) {
  var columns = _ref.columns,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? [{}] : _ref$rows,
      sortHandler = _ref.sortHandler,
      searchBar = _ref.searchBar,
      resizableColumns = _ref.resizableColumns,
      nextPageLink = _ref.nextPageLink,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      onScrollEnd = _ref.onScrollEnd,
      infiniteScrollLoadingText = _ref.infiniteScrollLoadingText,
      _ref$isInsideModal = _ref.isInsideModal,
      isInsideModal = _ref$isInsideModal === void 0 ? false : _ref$isInsideModal,
      _ref$allowRowSelect = _ref.allowRowSelect,
      allowRowSelect = _ref$allowRowSelect === void 0 ? false : _ref$allowRowSelect,
      onRowSelect = _ref.onRowSelect,
      highlightedRow = _ref.highlightedRow,
      _ref$allowDraggableRo = _ref.allowDraggableRow,
      allowDraggableRow = _ref$allowDraggableRo === void 0 ? false : _ref$allowDraggableRo,
      onDragEnd = _ref.onDragEnd,
      addNewRow = _ref.addNewRow,
      columnsForNewRow = _ref.columnsForNewRow,
      noDataMessage = _ref.noDataMessage,
      _ref$hideNewRowHeader = _ref.hideNewRowHeader,
      hideNewRowHeader = _ref$hideNewRowHeader === void 0 ? false : _ref$hideNewRowHeader,
      _ref$noHeaderBackgrou = _ref.noHeaderBackground,
      noHeaderBackground = _ref$noHeaderBackgrou === void 0 ? false : _ref$noHeaderBackgrou;
  var tableNode = (0, _react.useRef)();
  var containerNode = (0, _react.useRef)();
  var headerProps = {
    sortHandler: sortHandler,
    columns: columns,
    tableNode: tableNode,
    resizableColumns: resizableColumns,
    isSearchVisible: Boolean(searchBar)
  };
  var tableWidth = useTableWidth();

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchText = _useState4[0],
      setSearchText = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      expandedRows = _useState6[0],
      setExpandedRows = _useState6[1];

  var handleExpandedRows = function handleExpandedRows(expandedRowId) {
    var onExpand = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var row = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var expandedRowsList = _toConsumableArray(expandedRows);

    var index = expandedRowsList === null || expandedRowsList === void 0 ? void 0 : expandedRowsList.indexOf(expandedRowId);

    if (index !== -1) {
      expandedRowsList === null || expandedRowsList === void 0 ? void 0 : expandedRowsList.splice(index, 1);
    } else {
      expandedRowsList === null || expandedRowsList === void 0 ? void 0 : expandedRowsList.push(expandedRowId);
      onExpand(row);
    }

    setExpandedRows(expandedRowsList);
  };

  var onChangeSearch = function onChangeSearch(e) {
    setSearchText(e.target.value);
    searchBar.onSearch(e.target.value);
  };

  var getWidth = function getWidth() {
    if (tableNode && tableNode.current) {
      return Math.max(tableWidth, tableNode.current.offsetWidth);
    } else {
      return tableWidth;
    }
  };

  (0, _react.useEffect)(function () {
    if (searchBar !== null && searchBar !== void 0 && searchBar.isSearchEmpty) {
      setSearchText('');
    }
  }, [searchBar === null || searchBar === void 0 ? void 0 : searchBar.isSearchEmpty]);

  var columnContent = _toConsumableArray(columns);

  if (columns && allowDraggableRow) {
    columnContent.splice(0, 0, {
      field: 'dragNDrop',
      headerName: '',
      sortable: false,
      renderColumn: function renderColumn() {
        return /*#__PURE__*/_react.default.createElement("img", {
          src: _dragAndDrop.default
        });
      },
      width: '50px'
    });
    headerProps.columns = columnContent;
  }

  headerProps.hideNewRowHeader = hideNewRowHeader;
  headerProps.noHeaderBackground = noHeaderBackground;

  var renderTable = function renderTable() {
    return allowDraggableRow ? /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
      onDragEnd: onDragEnd
    }, /*#__PURE__*/_react.default.createElement("table", {
      ref: tableNode,
      className: _constants.classes.table,
      role: _constants.tableRole,
      "aria-label": _constants.tableAriaLabel
    }, /*#__PURE__*/_react.default.createElement(TableHeader, headerProps), /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
      droppableId: "droppable-container"
    }, function (provider) {
      return /*#__PURE__*/_react.default.createElement("tbody", _extends({
        ref: provider.innerRef
      }, provider.droppableProps, {
        tabIndex: _constants.tabIndex
      }), rows && rows.length > 0 ? rows.map(function (row, index) {
        var props = {
          row: row,
          rowIndex: index,
          columns: columnContent,
          highlightedRow: highlightedRow,
          allowRowSelect: allowRowSelect,
          allowDraggableRow: allowDraggableRow,
          handleExpandedRows: handleExpandedRows,
          expandedRows: expandedRows,
          noDataMessage: noDataMessage
        };

        if (allowRowSelect) {
          props.onClick = function (e) {
            return onRowSelect(row, e);
          };
        }

        return /*#__PURE__*/_react.default.createElement(TableRow, _extends({
          key: "".concat(_constants.tableRowPrefix, "-").concat(index)
        }, props));
      }) : /*#__PURE__*/_react.default.createElement(_TableWithNoData.default, {
        noDataMessage: noDataMessage,
        columns: columns
      }), provider.placeholder);
    }))) : /*#__PURE__*/_react.default.createElement("table", {
      ref: tableNode,
      className: _constants.classes.table,
      role: _constants.tableRole,
      "aria-label": _constants.tableAriaLabel
    }, /*#__PURE__*/_react.default.createElement(TableHeader, headerProps), /*#__PURE__*/_react.default.createElement("tbody", {
      tabIndex: _constants.tabIndex
    }, rows && rows.length > 0 ? rows.map(function (row, index) {
      var props = {
        row: row,
        rowIndex: index,
        columns: columnContent,
        highlightedRow: highlightedRow,
        allowRowSelect: allowRowSelect,
        allowDraggableRow: allowDraggableRow,
        handleExpandedRows: handleExpandedRows,
        expandedRows: expandedRows,
        noDataMessage: noDataMessage
      };

      if (allowRowSelect) {
        props.onClick = function (e) {
          return onRowSelect(row, e);
        };
      }

      return /*#__PURE__*/_react.default.createElement(TableRow, _extends({
        key: "".concat(_constants.tableRowPrefix, "-").concat(index)
      }, props));
    }) : /*#__PURE__*/_react.default.createElement(_TableWithNoData.default, {
      noDataMessage: noDataMessage,
      columns: columns
    })));
  };

  var infiniteModalProps = {};

  if (isInsideModal) {
    infiniteModalProps = {
      height: 'calc(100vh - 160px)',
      className: _constants.classes.infiniteScrollInsideModal
    };
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    ref: containerNode,
    className: _constants.classes.container
  }, searchBar && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.search,
    style: getWidth() ? {
      width: getWidth()
    } : {},
    role: _constants.navigationRole,
    tabIndex: _constants.tabIndex
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.searchContainer
  }, /*#__PURE__*/_react.default.createElement(_search.default, {
    value: searchText,
    onChange: onChangeSearch,
    disabled: Boolean(searchBar === null || searchBar === void 0 ? void 0 : searchBar.isDisabled),
    width: _constants.searchBarSize,
    placeholder: (searchBar === null || searchBar === void 0 ? void 0 : searchBar.placeholder) || ''
  }))), hasInfiniteScroll && rows.length !== 0 ? /*#__PURE__*/_react.default.createElement(_reactInfiniteScrollComponent.default, _extends({
    dataLength: (rows === null || rows === void 0 ? void 0 : rows.length) || 0,
    hasMore: !!nextPageLink,
    next: onScrollEnd,
    loader: infiniteScrollLoadingText,
    scrollThreshold: 1
  }, infiniteModalProps), renderTable()) : renderTable(), addNewRow && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_constants.classes.addNewRow, " ").concat((rows === null || rows === void 0 ? void 0 : rows.length) === 0 ? _constants.classes.emptyNewRowHeader : {})
  }, /*#__PURE__*/_react.default.createElement(Table, {
    hideNewRowHeader: (rows === null || rows === void 0 ? void 0 : rows.length) === 0,
    columns: columnsForNewRow
  })));
};
/***
 *  Resizing will take the delta of current cursor position and initial cursor
 *  position when mousedown event (press down and Drag) ocurred.
 *
 *  InitialCursorPosition = right of the column/header Bounding client rect
 *
 *  deltaMousePosition = InitialCursorPosition - currentCursorPosition
 *  = Length the mouse has moved.
 *
 *  The width of the current column:
 *  (current width of column/header cell)  + (Length the mouse has moved.)
 *
 *  The width of the adjacent column:
 *
 * (current width of adjacent column/header cell) - (length the mouse has moved.)
 *
 *  Resizing is done only if both column width are >= 88 pixels
 */


var resizeHelper = function resizeHelper(_ref2) {
  var currentColumn = _ref2.currentColumn,
      adjacentColumn = _ref2.adjacentColumn,
      currentCursorPosition = _ref2.currentCursorPosition,
      tableWidth = _ref2.tableWidth;

  // obtain current header cell width and right of the bounding element rectangle
  var _currentColumn$getBou = currentColumn.getBoundingClientRect(),
      currentColumnWidth = _currentColumn$getBou.width,
      currentColumnRight = _currentColumn$getBou.right; // obtain the adjacent column width from bounding client Rect


  var _adjacentColumn$getBo = adjacentColumn.getBoundingClientRect(),
      adjacentColumnWidth = _adjacentColumn$getBo.width;

  var initialMousePosition = currentColumnRight + window.pageXOffset - _constants.resizerWidth;
  var deltaMousePosition = currentCursorPosition - initialMousePosition; // the length of mouse moved is added to current header width
  // the same is subtracted from adjacent column width

  var currentColumnNewWidth = currentColumnWidth + deltaMousePosition;
  var adjacentColumnNewWidth = adjacentColumnWidth - deltaMousePosition;

  if (currentColumnNewWidth >= _constants.columnMinWidth && adjacentColumnNewWidth >= _constants.columnMinWidth) {
    // plug in width percentage value for responsiveness
    currentColumn.style.width = "".concat(currentColumnNewWidth / tableWidth * _constants.HUNDRED_DECIMAL, "%");
    adjacentColumn.style.width = "".concat((adjacentColumnWidth - deltaMousePosition) / tableWidth * _constants.HUNDRED_DECIMAL, "%");
  }
};

var TableHeader = function TableHeader(_ref3) {
  var columns = _ref3.columns,
      sortHandler = _ref3.sortHandler,
      tableNode = _ref3.tableNode,
      resizableColumns = _ref3.resizableColumns,
      isSearchVisible = _ref3.isSearchVisible,
      hideNewRowHeader = _ref3.hideNewRowHeader,
      noHeaderBackground = _ref3.noHeaderBackground;

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      sortedColumn = _useState8[0],
      setSortedColumn = _useState8[1];

  var headerSortHandler = function headerSortHandler(fieldName) {
    sortedColumn !== fieldName && setSortedColumn(fieldName);
  };

  var _useState9 = (0, _react.useState)(columns.map(function () {
    return (0, _react.useRef)();
  })),
      _useState10 = _slicedToArray(_useState9, 1),
      headerRefs = _useState10[0];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      resizerFocus = _useState12[0],
      setResizerFocus = _useState12[1];

  var _useState13 = (0, _react.useState)({}),
      _useState14 = _slicedToArray(_useState13, 2),
      filterValues = _useState14[0],
      setFilterValues = _useState14[1];

  var resizeHandler = function resizeHandler(event, index) {
    var _headerRefs$index;

    if (!resizableColumns) return;
    var currentColumn = (_headerRefs$index = headerRefs[index]) === null || _headerRefs$index === void 0 ? void 0 : _headerRefs$index.current;
    var adjacentColumn = headerRefs[index + 1].current;
    var tableElement = tableNode.current;
    var currentCursorPosition = event.pageX;
    var tableWidth = tableElement.offsetWidth;
    if (!tableElement && !currentColumn && !adjacentColumn) return;
    resizeHelper({
      currentColumn: currentColumn,
      adjacentColumn: adjacentColumn,
      currentCursorPosition: currentCursorPosition,
      tableWidth: tableWidth
    });
  };

  (0, _react.useEffect)(function () {
    // convert all width to percentage for responsiveness
    // this will run only once since the refs would be defined on mount
    // only once through out the component lifecycle
    var tableElement = tableNode === null || tableNode === void 0 ? void 0 : tableNode.current;

    if (tableElement && resizableColumns) {
      columns.map(function (_, columnNo) {
        var _headerRefs$columnNo;

        var headerElement = (_headerRefs$columnNo = headerRefs[columnNo]) === null || _headerRefs$columnNo === void 0 ? void 0 : _headerRefs$columnNo.current;

        if (headerElement) {
          var origWidth = headerElement.offsetWidth;
          var tableWidth = tableElement.offsetWidth;
          headerElement.style.width = "".concat(origWidth / tableWidth * _constants.HUNDRED_DECIMAL, "%");

          if (isSearchVisible) {
            headerElement.style.top = _constants.tableSearchHeight;
          }
        }
      });
    }
  }, [tableNode].concat(_toConsumableArray(headerRefs)));
  return /*#__PURE__*/_react.default.createElement("thead", {
    tabIndex: _constants.tabIndex
  }, /*#__PURE__*/_react.default.createElement("tr", {
    tabIndex: _constants.tabIndex,
    className: _constants.classes.header,
    onMouseLeave: function onMouseLeave() {
      return setResizerFocus(false);
    },
    onMouseOver: function onMouseOver() {
      return setResizerFocus(true);
    }
  }, columns && columns.map(function (column, index) {
    var headerName = column.headerName,
        sortable = column.sortable,
        field = column.field,
        renderHeader = column.renderHeader;
    var reset = sortedColumn !== field;
    var iconProps = {
      sortHandler: sortHandler,
      field: field,
      reset: reset,
      headerSortHandler: headerSortHandler
    };
    var tableHeaderCellProp = {
      column: column,
      columnLength: columns.length,
      index: index,
      headerName: headerName,
      renderHeader: renderHeader,
      sortable: sortable,
      iconProps: iconProps,
      resizeHandler: resizeHandler,
      resizableColumns: resizableColumns,
      resizerFocus: resizerFocus,
      setResizerFocus: setResizerFocus
    };
    return /*#__PURE__*/_react.default.createElement(TableHeaderCell, _extends({
      key: "".concat(index),
      ref: headerRefs[index]
    }, tableHeaderCellProp, {
      filterValues: filterValues,
      setFilterValues: setFilterValues,
      hideNewRowHeader: hideNewRowHeader,
      noHeaderBackground: noHeaderBackground
    }));
  })));
};

var TableHeaderCell = /*#__PURE__*/_react.default.forwardRef(function (_ref4, tableHeaderRef) {
  var _resizerClasses, _column$filter2, _sortClasses;

  var column = _ref4.column,
      index = _ref4.index,
      headerName = _ref4.headerName,
      renderHeader = _ref4.renderHeader,
      sortable = _ref4.sortable,
      iconProps = _ref4.iconProps,
      resizeHandler = _ref4.resizeHandler,
      columnLength = _ref4.columnLength,
      resizableColumns = _ref4.resizableColumns,
      setResizerFocus = _ref4.setResizerFocus,
      resizerFocus = _ref4.resizerFocus,
      filterValues = _ref4.filterValues,
      setFilterValues = _ref4.setFilterValues,
      hideNewRowHeader = _ref4.hideNewRowHeader,
      noHeaderBackground = _ref4.noHeaderBackground;
  var columnFilterRef = (0, _react.useRef)();

  var parentResizeHandler = function parentResizeHandler(e) {
    e.stopPropagation();
    if (!resizableColumns) return;
    setResizerFocus(true);
    resizeHandler(e, index);
  };

  var resizerClasses = (_resizerClasses = {}, _defineProperty(_resizerClasses, _constants.classes.resizer, true), _defineProperty(_resizerClasses, _constants.classes.resizerHover, resizerFocus), _resizerClasses);

  var resizeInit = function resizeInit(_) {
    document.addEventListener(_constants.mousemoveEvent, parentResizeHandler);
  };

  (0, _react.useLayoutEffect)(function () {
    if (index !== columnLength - 1 && tableHeaderRef !== null && tableHeaderRef !== void 0 && tableHeaderRef.current && resizableColumns) {
      tableHeaderRef.current.addEventListener(_constants.mousedownEvent, resizeInit);
      document.addEventListener(_constants.mouseupEvent, function () {
        setResizerFocus(false);
        if (tableHeaderRef && tableHeaderRef.current) document.removeEventListener(_constants.mousemoveEvent, parentResizeHandler);
      });
    }
  }, [tableHeaderRef]);
  (0, _react.useEffect)(function () {
    if (columnFilterRef !== null && columnFilterRef !== void 0 && columnFilterRef.current) {
      columnFilterRef.current.addEventListener(_constants.mousedownEvent, function (e) {
        // To prevent resize event from being triggered
        e.stopPropagation();
      });
    }
  }, [columnFilterRef]);

  var _useState15 = (0, _react.useState)(_constants.sortingType.unsorted),
      _useState16 = _slicedToArray(_useState15, 2),
      sortType = _useState16[0],
      setSortType = _useState16[1];

  (0, _react.useEffect)(function () {
    iconProps.reset && setSortType(_constants.sortingType.unsorted);
  }, [iconProps.reset]);
  (0, _react.useEffect)(function () {
    var _column$filter;

    setFilterValues((_column$filter = column.filter) === null || _column$filter === void 0 ? void 0 : _column$filter.selectedFilters);
  }, [JSON.stringify((_column$filter2 = column.filter) === null || _column$filter2 === void 0 ? void 0 : _column$filter2.selectedFilters)]);

  var getSortIcon = function getSortIcon(sortType) {
    switch (sortType) {
      case _constants.sortingType.ascending:
        return _columnAscending.default;

      case _constants.sortingType.descending:
        return _columnsDescending.default;

      default:
        return _columnUnsorted.default;
    }
  };

  var getNextType = function getNextType() {
    switch (sortType) {
      case _constants.sortingType.ascending:
        return _constants.sortingType.descending;

      case _constants.sortingType.descending:
        return _constants.sortingType.unsorted;

      case _constants.sortingType.unsorted:
        return _constants.sortingType.ascending;

      default:
        return _constants.sortingType.unsorted;
    }
  };

  var clickHandler = function clickHandler() {
    var nextType = getNextType();
    iconProps.headerSortHandler(iconProps.field);
    setSortType(nextType);
    iconProps.sortHandler(nextType, iconProps.field);
  };

  var sortClasses = (_sortClasses = {}, _defineProperty(_sortClasses, _constants.classes.headerTextIconContainer, true), _defineProperty(_sortClasses, _constants.classes.headerCursor, sortable), _sortClasses);

  var handleOnApply = function handleOnApply(field, currentFilterValues) {
    var columnFilters = _objectSpread({}, filterValues); // To store filter values based on column name


    columnFilters[field] = currentFilterValues;
    setFilterValues(columnFilters);
    column.filter.onApply(columnFilters);
  };

  return /*#__PURE__*/_react.default.createElement("th", {
    className: noHeaderBackground ? _constants.classes.headerCellNoBackground : _constants.classes.headerCell,
    style: {
      width: column.width,
      minWidth: _constants.columnMinWidthPixels
    },
    key: "".concat(_constants.tableHeaderPrefix, "-").concat(index),
    tabIndex: _constants.tabIndex,
    title: headerName,
    ref: tableHeaderRef
  }, !hideNewRowHeader && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, typeof renderHeader === 'function' ? renderHeader() : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(sortClasses)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.headerText,
    tabIndex: _constants.tabIndex,
    onClick: function onClick() {
      return sortable && clickHandler();
    }
  }, headerName), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.sortIconResizeContainer
  }, sortable && /*#__PURE__*/_react.default.createElement("span", {
    className: _constants.classes.headerIcon,
    tabIndex: _constants.tabIndex,
    onClick: function onClick() {
      return clickHandler();
    },
    onMouseEnter: function onMouseEnter() {
      return setResizerFocus(false);
    },
    onMouseOver: function onMouseOver(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: getSortIcon(sortType),
    alt: "".concat(sortType, "-").concat(_constants.sortIconSuffix),
    title: "".concat(sortType)
  })), column.showFilter && /*#__PURE__*/_react.default.createElement("div", {
    ref: columnFilterRef,
    className: _constants.classes.columnFilter,
    onMouseEnter: function onMouseEnter() {
      return setResizerFocus(false);
    },
    onMouseOver: function onMouseOver(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement(_ColumnFilter.default, {
    onApply: function onApply(currentFilterValues) {
      return handleOnApply(column.field, currentFilterValues);
    },
    options: column.filter.options,
    singleSelector: column.filter.singleSelector,
    values: filterValues === null || filterValues === void 0 ? void 0 : filterValues[column.field]
  })), index !== columnLength - 1 && resizableColumns && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(resizerClasses),
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }))))));
});

var renderTableRow = function renderTableRow(row, columns, rowIndex) {
  var dragHandleProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var handleExpandedRows = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var expandedRows = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var isSubRow = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var arrTableCells = [];

  for (var fieldIndex = 0; fieldIndex < columns.length; fieldIndex++) {
    var column = columns[fieldIndex];
    arrTableCells.push( /*#__PURE__*/_react.default.createElement(TableCell, {
      key: "".concat(_constants.tableCellPrefix).concat(rowIndex, "-").concat(fieldIndex),
      value: row[column.field],
      horizontalAlignment: column.horizontalAlignment,
      width: column.width,
      renderColumn: column.renderColumn,
      allowExpand: column.allowExpand,
      row: row,
      dragHandleProps: dragHandleProps,
      index: rowIndex,
      handleExpandedRows: handleExpandedRows,
      renderTableRow: renderTableRow,
      expandedRows: expandedRows,
      onExpand: column.onExpand,
      isSubRow: isSubRow
    }));
  }

  return arrTableCells;
};

var TableRow = function TableRow(_ref5) {
  var _row$subRows;

  var row = _ref5.row,
      columns = _ref5.columns,
      rowIndex = _ref5.rowIndex,
      highlightedRow = _ref5.highlightedRow,
      allowRowSelect = _ref5.allowRowSelect,
      allowDraggableRow = _ref5.allowDraggableRow,
      handleExpandedRows = _ref5.handleExpandedRows,
      expandedRows = _ref5.expandedRows,
      noDataMessage = _ref5.noDataMessage,
      restProps = _objectWithoutProperties(_ref5, _excluded);

  var isHighlighted = (0, _lodash.isEqual)(row, highlightedRow);
  return allowDraggableRow ? /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Draggable, {
    key: rowIndex,
    draggableId: rowIndex.toString(),
    index: rowIndex,
    style: function style(_isDragging, draggableStyle) {
      return _objectSpread(_objectSpread({}, draggableStyle), {}, {
        position: 'static'
      });
    }
  }, function (provider) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("tr", _extends({}, provider.draggableProps, {
      ref: provider.innerRef,
      "data-testid": _constants.classes.row,
      className: "".concat(_constants.classes.row, " ").concat(isHighlighted ? _constants.classes.rowHighlighted : '', " ").concat(allowRowSelect ? _constants.classes.rowSelectable : '')
    }, restProps), row && renderTableRow(row, columns, rowIndex, provider.dragHandleProps, handleExpandedRows, expandedRows)));
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("tr", _extends({
    "data-testid": _constants.classes.row,
    className: "".concat(_constants.classes.row, " ").concat(isHighlighted ? _constants.classes.rowHighlighted : '', " ").concat(allowRowSelect ? _constants.classes.rowSelectable : '')
  }, restProps), row && renderTableRow(row, columns, rowIndex, {}, handleExpandedRows, expandedRows)), (expandedRows === null || expandedRows === void 0 ? void 0 : expandedRows.includes(rowIndex)) && ((row === null || row === void 0 ? void 0 : (_row$subRows = row.subRows) === null || _row$subRows === void 0 ? void 0 : _row$subRows.length) > 0 ? row.subRows.map(function (subRow, index) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: "".concat(rowIndex, "-").concat(index),
      className: "".concat(_constants.classes.row, " ").concat(_constants.classes.expandedRow)
    }, renderTableRow(subRow, columns, subRow === null || subRow === void 0 ? void 0 : subRow.id, {}, function () {}, [], true));
  }) : /*#__PURE__*/_react.default.createElement("tr", {
    className: _constants.classes.row
  }, /*#__PURE__*/_react.default.createElement("td", {
    className: "".concat(_constants.classes.expandedCellRender, " ").concat(_constants.classes.render),
    colSpan: columns === null || columns === void 0 ? void 0 : columns.length
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.noDataFound
  }, noDataMessage)))));
};

var TableCell = function TableCell(_ref6) {
  var _cellClasses;

  var value = _ref6.value,
      horizontalAlignment = _ref6.horizontalAlignment,
      width = _ref6.width,
      renderColumn = _ref6.renderColumn,
      row = _ref6.row,
      _ref6$dragHandleProps = _ref6.dragHandleProps,
      dragHandleProps = _ref6$dragHandleProps === void 0 ? {} : _ref6$dragHandleProps,
      index = _ref6.index,
      _ref6$handleExpandedR = _ref6.handleExpandedRows,
      handleExpandedRows = _ref6$handleExpandedR === void 0 ? function () {} : _ref6$handleExpandedR,
      allowExpand = _ref6.allowExpand,
      expandedRows = _ref6.expandedRows,
      _ref6$onExpand = _ref6.onExpand,
      onExpand = _ref6$onExpand === void 0 ? function () {} : _ref6$onExpand,
      _ref6$isSubRow = _ref6.isSubRow,
      isSubRow = _ref6$isSubRow === void 0 ? false : _ref6$isSubRow;
  var cellClasses = (_cellClasses = {}, _defineProperty(_cellClasses, _constants.classes.cell, !renderColumn), _defineProperty(_cellClasses, _constants.classes.render, renderColumn), _cellClasses);
  var isRowExpandable = typeof allowExpand === 'boolean' ? allowExpand : typeof allowExpand === 'function' ? allowExpand(row) : false;
  var isExpanded = expandedRows === null || expandedRows === void 0 ? void 0 : expandedRows.includes(index);

  var handleMouseDown = function handleMouseDown(mouseDownEvent) {
    if ((0, _lodash.isEmpty)(dragHandleProps)) {
      return;
    }

    mouseDownEvent.currentTarget.focus();
  };

  return /*#__PURE__*/_react.default.createElement("td", _extends({
    style: {
      width: width,
      textAlign: horizontalAlignment,
      paddingLeft: allowExpand && (!isRowExpandable || isSubRow) ? '2.625rem' : '1rem'
    },
    className: (0, _classnames.default)(cellClasses),
    tabIndex: _constants.tabIndex,
    title: value
  }, dragHandleProps, {
    onMouseDown: handleMouseDown
  }), renderColumn && /*#__PURE__*/_react.default.createElement("div", {
    tabIndex: _constants.tabIndex,
    className: _constants.classes.cellRender
  }, isRowExpandable && !isSubRow && /*#__PURE__*/_react.default.createElement(_ExpandRowIcon.default, {
    isExpanded: isExpanded,
    onClick: function onClick() {
      return handleExpandedRows(index, onExpand, row);
    }
  }), renderColumn(row, value, index)) || /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.expandRow
  }, isRowExpandable && !isSubRow && /*#__PURE__*/_react.default.createElement(_ExpandRowIcon.default, {
    isExpanded: isExpanded,
    onClick: function onClick() {
      return handleExpandedRows(index, onExpand, row);
    }
  }), /*#__PURE__*/_react.default.createElement("span", null, value)));
};

Table.propTypes = {
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    field: _propTypes.default.string,
    headerName: _propTypes.default.string.isRequired,
    renderHeader: _propTypes.default.func,
    sortable: _propTypes.default.bool,
    width: _propTypes.default.string,
    horizontalAlignment: _propTypes.default.string,
    onExpand: _propTypes.default.func,
    allowExpand: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func])
  })).isRequired,
  rows: _propTypes.default.arrayOf(_propTypes.default.object),
  sortHandler: _propTypes.default.func,
  searchBar: _propTypes.default.shape({
    onSearch: _propTypes.default.func.isRequired,
    placeholder: _propTypes.default.string
  }),
  verticalScroll: _propTypes.default.bool,
  horizontalScroll: _propTypes.default.bool,
  isInsideModal: _propTypes.default.bool,
  allowRowSelect: _propTypes.default.bool,
  onRowSelect: _propTypes.default.func,
  highlightedRow: _propTypes.default.object,
  noDataMessage: _propTypes.default.string
};
var _default = Table;
exports.default = _default;